import { useEffect, useState } from 'react';

import { useGlobalError } from 'hooks/useGlobalError';
import { paymentService } from 'services/payment/paymentService';
import { OrganizationDto } from 'services/payment/paymentService.dto';

const SEARCH_DEBOUNCE_MS = 300;

export const useSearchOrganizations = (searchPhrase: string) => {
  const [organizations, setOrganizations] = useState<OrganizationDto[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const { unknownError } = useGlobalError();

  const adjustedSearchPhrase = adjustSearchPhrase(searchPhrase);

  useEffect(() => {
    if (!adjustedSearchPhrase) {
      setOrganizations([]);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    const timeoutId = setTimeout(() => {
      const keywords: string[] = adjustedSearchPhrase.split(' ');
      paymentService
        .fetchOrganizationsByKeywords(keywords)
        .then(result => setOrganizations(result.data))
        .catch(() => {
          setOrganizations([]);
          unknownError();
        })
        .finally(() => setIsLoading(false));
    }, SEARCH_DEBOUNCE_MS);

    return () => clearTimeout(timeoutId);
  }, [adjustedSearchPhrase]);

  return { organizations, isLoading };
};

const adjustSearchPhrase = (searchPhrase: string) => {
  const trimmedSearchPhrase = searchPhrase.trim();
  return !!trimmedSearchPhrase ? trimmedSearchPhrase : undefined;
};
